var RegionsEnum;
(function (RegionsEnum) {
    RegionsEnum["AC"] = "Acre";
    RegionsEnum["AL"] = "Alagoas";
    RegionsEnum["AP"] = "Amap\u00E1";
    RegionsEnum["AM"] = "Amazonas";
    RegionsEnum["BA"] = "Bahia";
    RegionsEnum["CE"] = "Cear\u00E1";
    RegionsEnum["DF"] = "Distrito Federal";
    RegionsEnum["ES"] = "Espirito Santo";
    RegionsEnum["GO"] = "Goi\u00E1s";
    RegionsEnum["MA"] = "Maranh\u00E3o";
    RegionsEnum["MT"] = "Mato Grosso";
    RegionsEnum["MS"] = "Mato Grosso do Sul";
    RegionsEnum["MG"] = "Minas Gerais";
    RegionsEnum["PA"] = "Par\u00E1";
    RegionsEnum["PB"] = "Para\u00EDba";
    RegionsEnum["PR"] = "Paran\u00E1";
    RegionsEnum["PE"] = "Pernambuco";
    RegionsEnum["PI"] = "Piau\u00ED";
    RegionsEnum["RJ"] = "Rio de Janeiro";
    RegionsEnum["RN"] = "Rio Grande do Norte";
    RegionsEnum["RS"] = "Rio Grande do Sul";
    RegionsEnum["RO"] = "Rond\u00F4nia";
    RegionsEnum["RR"] = "Roraima";
    RegionsEnum["SC"] = "Santa Catarina";
    RegionsEnum["SP"] = "S\u00E3o Paulo";
    RegionsEnum["SE"] = "Sergipe";
    RegionsEnum["TO"] = "Tocantins";
})(RegionsEnum || (RegionsEnum = {}));
export {};
//# sourceMappingURL=index.js.map